/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Row,
  Col,
  Spin,
  Card,
  Button,
  Input,
  DatePicker,
  message,
} from 'antd';

import { onError } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import Select from 'components/Select';
import NumericInput from 'components/NumericInput';
import ModalDelete from 'components/ModalDelete';
import { hasActionPermission, ActionsNames } from 'utils/permission/index';
import {
  getDetallesContratosFoliosPlacas,
  getDetalleContratoFolioPlaca,
  patchDetalleContratoFolioPlaca,
  postDetalleContratoFolioPlaca,
  deleteDetalleContratoFolioPlaca,
} from 'api/recaudacion/detalleContratoFoliosPlacas';
import { getTiposFoliosVehiculares } from 'api/recaudacion/tipoFolioVehicular';
// import { getTiposDeVehiculos } from 'api/recaudacion/tipoVehiculo';
// import { getServiciosDeVehiculo } from 'api/recaudacion/servicioDeVehiculo';
import {
  getTiposDeVehiculos,
  getServiciosDeVehiculo,
} from 'api/recaudacion/index';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';

const catalogsModel = [

  'tipofoliovehicular',
  'tipodevehiculo',
  'serviciodelvehiculo',

];

const DetalleContratoFolioPlaca = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const estadosGlobales = useSelector(({ catalogs }) => catalogs.estadosGlobales);
  const [hasActionPermissions, setHasActionPermissions] = useState(true);
  const [tipoFolioVehicular, setTipoFolioVehicular] = useState([]);
  const [tipoVehiculo, setTipoVehiculo] = useState([]);
  const [servicioDeVehiculo, setServicioDeVehiculo] = useState([]);
  const [formInfo] = Form.useForm();

  const fetchData = async () => {
    setLoading(true);
    const _data = await getDetallesContratosFoliosPlacas();
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const validatePermission = () => {
      const _hasAllViewPermission = catalogsModel
        .map((m) => hasActionPermission(m, ActionsNames.view))
        .every((e) => e);
      if (!_hasAllViewPermission) {
        message.warn('Hacen falta permisos en los catálogos relacionados a este módulo');
      }
      if (mounted) {
        setHasActionPermissions(_hasAllViewPermission);
      }
    };
    validatePermission();
    const fetchAll = async () => {
      setLoading(true);
      const tipoFolioV = await getTiposFoliosVehiculares();
      const _tipoVehiculo = await getTiposDeVehiculos();
      const _servicioVehiculo = await getServiciosDeVehiculo();
      const _data = await getDetallesContratosFoliosPlacas();
      if (mounted) {
        setTipoFolioVehicular(tipoFolioV || []);
        setTipoVehiculo(_tipoVehiculo || []);
        setServicioDeVehiculo(_servicioVehiculo || []);
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
    setSelectedRowKeys([]);
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickEdit = async () => {
    const [key] = selectedRowKeys;
    const match = await getDetalleContratoFolioPlaca(key);
    if (match) {
      setVisible(true);
      form.setFieldsValue(match);
      formInfo.setFieldsValue(match);
    }
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue({
      ...record,
      tipoFolioVehicular: record.tipoFolioVehicular.id,
    });
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formInfo.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formInfo.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const _data = await (key ? patchDetalleContratoFolioPlaca(key, values)
        : postDetalleContratoFolioPlaca(values));
      if (_data) {
        await fetchData();
        if (_continue) {
          if (!key) {
            setSelectedRowKeys([_data.id]);
            setTimeout(() => onClickEdit(_data));
          } else {
            setTimeout(() => onClickEdit());
          }
        } else {
          onCancel();
        }
      }
      setLoading(false);
      return true;
    } catch (err) {
      onError(err, setLoading, [form, formInfo]);
      return false;
    }
  };

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteDetalleContratoFolioPlaca(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  /*
  const reset = () => {
    setTipoFolioVehicular([]);
    setTipoDeVehiculoFound([]);
    form.resetFields(['q']);
    form.validateFields(['q']);
  };
  */
  const rules = {
    required: [
      {
        required: true,
        message: 'El campo es requerido',
      },
    ],
  };

  const columns = [
    {
      titleText: 'Tipo Folio Vehícular',
      dataIndex: 'tipo_folio_vehicular',
      key: 'tipo_folio_vehicular',
      width: 300,
      render: (val) => (tipoFolioVehicular.find((item) => item.id === val)?.descripcion),
    },
    {
      titleText: 'Tipo de Vehículo',
      dataIndex: 'tipo_de_vehiculo',
      key: 'tipo_de_vehiculo',
      width: 300,
      render: (val) => (tipoVehiculo.find((item) => item.id === val)?.nombre),
    },
    {
      titleText: 'Servicio del Vehículo',
      dataIndex: 'servicio_del_vehiculo',
      key: 'servicio_del_vehiculo',
      width: 300,
      render: (val) => (servicioDeVehiculo.find((item) => item.id === val)?.nombre),
    },
    {
      titleText: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
      width: 300,
    },
    {
      titleText: 'Folio Inicial',
      dataIndex: 'folio_inicial',
      key: 'folio_inicial',
      width: 300,
    },
    {
      titleText: 'Folio Final',
      dataIndex: 'folio_final',
      key: 'folio_final',
      width: 300,
    },
    {
      titleText: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
      width: 300,
      render: (val) => val?.format(DATE_FRONTEND_FORMAT),
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => (estadosGlobales.find((item) => item.id === val)?.descripcion),
      catalog: {
        cat: estadosGlobales,
        labelProp: 'descripcion',
      },
    },
  ];

  return (
    <Row align="center" justify="center" className="container">
      <Col xs={24} sm={24} md={24}>
        <Spin
          tip="Cargando..."
          spinning={loading}
        >
          {!visible ? (
            <Table
              cols={columns}
              data={data}
              rowKey="id"
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={{
                onClickAdd,
                onClickEdit,
                onClickDelete,
              }}
              loading={loading}
              hasAllViewPermission={hasActionPermissions}
              permission={permission}
            />
          ) : (
            <Card
              visible={visible}
              title={(
                <FormSubmitControls
                  label={`${selectedRowKeys.length ? ' Editar' : 'Agregar'} Almacén Vehícular`}
                  onCancel={onCancel}
                  loading={loading}
                  onFinish={onFinish}
                  permission={permission}
                />
              )}
              bordered={false}
            >
              <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                initialValues={{ estados_globales: 1 }}
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="tipo_folio_vehicular"
                      label="Tipo de Folio Vehícular"
                    >
                      <Select
                        dataSource={tipoFolioVehicular}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="tipo_de_vehiculo"
                      label="Tipo de Vehículo"
                    >
                      <Select
                        dataSource={tipoVehiculo}
                        labelProp="nombre"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="servicio_del_vehiculo"
                      label="Servicio del Vehículo"
                    >
                      <Select
                        dataSource={servicioDeVehiculo}
                        labelProp="nombre"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <NumericInput
                      name="cantidad"
                      label="Cantidad"
                      required
                    />
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="folio_inicial"
                      label="Folio Inicial"
                      rules={rules.required}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="folio_final"
                      label="Folio Final"
                      rules={rules.required}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha"
                      label="Fecha"
                      hasFeedback
                      rules={rules.required}
                    >
                      <DatePicker
                        placeholder=""
                        format={DATE_FRONTEND_FORMAT}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="estados_globales"
                      rules={rules.required}
                      label="Estado"
                      hasFeedback
                    >
                      <Select dataSource={estadosGlobales} disabled={!selectedRowKeys.length} />
                    </Form.Item>
                  </Col>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Row>
              </Form>
            </Card>
          )}
          <ModalDelete
            onDelete={deleteItem}
            onCancel={() => setVisibleAlert(false)}
            visible={visibleAlert}
            content={`DetalleContratoFolioPlaca ${form.getFieldValue('nombre')}`}
            loading={loading}
          />
        </Spin>
      </Col>
    </Row>
  );
};

export default DetalleContratoFolioPlaca;
